export default __webpack_public_path__ + "media/images/pattern-8ff4e6afaa34e19e2f0e167152f36f4d.png";